// Core
import React from 'react';
import { Box, Flex, Text, Divider, Image, useColorMode } from '@chakra-ui/react';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';

// Components
import Card from 'components/Card/Card';

const TypesItem = ({ src, title, description, maxW, mt }) => {
    const cardTopLine = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 0%, #38A9E1 56.18%, #FFF 68.16%, #38A9E1 82.69%, rgba(56, 169, 225, 0.00) 100%)';
    const cardTopLineWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #38A9E1 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
    const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

    return (
        <Box className="animation-scale" mb={{base: '20px', md: '70px'}} position="relative">
            <Image className="animation-scale-target-home" 
                m="0 auto"
                mt={mt}
                zIndex="1" 
                src={src} 
                maxW={maxW} 
                w="100%" 
                alt={title} 
                transform="translate(-50%, 0px)"
                left="50%"
                position="absolute" />
            <Card padding="0px" overflow="hidden">
                <Box position="absolute" w="100%">
                    <Box bg={isDark ? cardTopLine : cardTopLineWhite} transform="rotate(180deg)" h="1px" />
                    { isDark && <Box bg="#099BFF" filter="blur(38px)" h="31px" />}
                </Box>

                <Box p={{base: '85px 16px 24px 16px', lg: '105px 16px 24px 16px'}} textAlign="center">
                    <Text zIndex="1" variant="header" fontSize="32px" fontStyle="normal">{title}</Text>

                    <Box zIndex="2" position="relative" w="100%" m="7px 0 8px 0">
                        <Box bg={isDark ? cardTopLine : cardTopLineWhite} transform="rotate(180deg)" h="2px" />
                        { isDark && <Box bg="#099BFF" filter="blur(38px)" w="100%" h="16px" position="absolute" />}
                    </Box>

                    <Text zIndex="3" position="relative">{description}</Text>
                </Box>

                { isDark ? (<Lines className="abstract-lines" style={{ zIndex: 1}} />) : (<LinesWhite className="abstract-lines" style={{ zIndex: 1, opacity: 0.3}}/>) }
            </Card>
        </Box>
    );
};


export default TypesItem;